if (!customElements.get('haiven-restock-notice')) {
  customElements.define('haiven-restock-notice', class extends HTMLElement {
    connectedCallback() {
      this.productInfo = this.closest('product-info');
      this.revision = 0;
      this.pending = false;
      this.unsubscribers = [];
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribers.push(subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({ data }) => {
          if (!this.productInfo?.contains(data?.event?.target)) return;
          this.revision++;
          this.pending = true;
          this.controller?.abort();
          this.hidden = true;
        }));
        this.unsubscribers.push(subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (String(data?.sectionId) !== this.dataset.section) return;
          this.revision++;
          this.pending = false;
          const source = this.findSource(data.html);
          if (!source || !data.variant || String(data.variant.id) !== source.dataset.variantId) {
            this.hidden = true;
            this.dataset.variantId = '';
            return;
          }
          this.applySource(source);
        }));
      }
      this.onResume = () => { if (!document.hidden) this.refresh(); };
      document.addEventListener('visibilitychange', this.onResume);
      window.addEventListener('pageshow', this.onResume);
      this.timer = setInterval(this.onResume, 60000);
      this.refresh();
    }

    disconnectedCallback() {
      this.revision++;
      this.controller?.abort();
      this.unsubscribers.forEach(unsubscribe => unsubscribe());
      clearInterval(this.timer);
      document.removeEventListener('visibilitychange', this.onResume);
      window.removeEventListener('pageshow', this.onResume);
    }

    findSource(html) {
      return Array.from(html?.querySelectorAll('haiven-restock-notice') || [])
        .find(node => node.dataset.section === this.dataset.section && node.dataset.productId === this.dataset.productId);
    }

    applySource(source) {
      const english = this.querySelector('span[dir="ltr"]');
      const sourceEnglish = source.querySelector('span[dir="ltr"]');
      if (english && sourceEnglish) english.textContent = sourceEnglish.textContent;
      this.dataset.variantId = source.dataset.variantId || '';
      this.dataset.available = source.dataset.available || 'unknown';
      this.hidden = !this.dataset.variantId || this.dataset.available !== 'false';
    }

    async refresh() {
      if (!this.isConnected || this.pending || document.hidden || !this.dataset.variantId) return;
      const revision = ++this.revision;
      const variantId = this.dataset.variantId;
      this.controller?.abort();
      this.controller = new AbortController();
      try {
        const url = new URL(this.dataset.productUrl, window.location.origin);
        if (url.origin !== window.location.origin) return;
        url.searchParams.set('variant', variantId);
        url.searchParams.set('section_id', this.dataset.section);
        const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: this.controller.signal });
        if (!response.ok) throw new Error('Availability unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (!this.isConnected || this.pending || revision !== this.revision) return;
        const source = this.findSource(html);
        if (!source || source.dataset.variantId !== variantId) {
          this.hidden = true;
          return;
        }
        this.applySource(source);
      } catch (error) {
        if (error.name !== 'AbortError' && revision === this.revision) this.hidden = true;
      }
    }
  });
}

